import { useToaster } from '@/components/shared/ToasterProvider'

type QueryResult<Data> = {
  data?: Data
  error?: { message: string }
  isError: boolean
  isSuccess: boolean
  isLoading: boolean
  isFetching: boolean
  isUninitialized: boolean
}

export default function useToastQuery<Data, Args extends any[]>(useQueryHook: (...args: Args) => QueryResult<Data>, ...args: Args) {
  const showToaster = useToaster()
  const result = useQueryHook(...args)
  const { isError, error } = result
  if (isError && error) {
    console.error(error)
    showToaster({ message: error.message })
  }

  return result
}
